import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ExcelIcon from '../assets/excel.svg';
import { actions } from '../actions';
import { useDispatch } from 'react-redux';
import { ITheme } from '../theme';

type ExcelButtonProps = {
  info: any;
  name: string;
  open: boolean;
  color: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  handleClose: () => {};
  handleExport: () => {};
  disabled: boolean;
  header: string;
};

const useStyles = makeStyles((theme: ITheme) => ({
  buttonExcelExport: {
    width: '100%',
    marginRight: 'auto',
    background: theme.palette.excel.main,
    color: theme.palette.white.main,
    '&:hover': {
      background: theme.palette.excel.light,
    },
  },
  imageExcel: {
    width: '20px',
    height: '20px',
    margin: '0 4px',
  },
  buttonExport: {
    marginBlock: 4,
    width: '100%',
  },
  buttonExport1: {
    backgroundColor: theme.palette.randomColor1.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor1.light,
    },
  },
  buttonExport2: {
    backgroundColor: theme.palette.randomColor2.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor2.light,
    },
  },
  buttonExport3: {
    backgroundColor: theme.palette.randomColor3.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor3.light,
    },
  },
  buttonExport4: {
    backgroundColor: theme.palette.randomColor4.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor4.light,
    },
  },
  buttonExport5: {
    backgroundColor: theme.palette.randomColor5.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor5.light,
    },
  },
  buttonExport6: {
    backgroundColor: theme.palette.randomColor6.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor6.light,
    },
  },
  buttonExport7: {
    backgroundColor: theme.palette.randomColor7.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor7.light,
    },
  },
  buttonExport8: {
    backgroundColor: theme.palette.randomColor8.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor8.light,
    },
  },
  buttonExport9: {
    backgroundColor: theme.palette.randomColor9.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor9.light,
    },
  },
  buttonExport10: {
    backgroundColor: theme.palette.randomColor10.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor10.light,
    },
  },
  buttonExport11: {
    backgroundColor: theme.palette.randomColor11.main,
    color: theme.palette.white.main,
    '&:hover': {
      backgroundColor: theme.palette.randomColor11.light,
    },
  },
}));

function ExcelButton(props: ExcelButtonProps) {
  const { info, name, handleClose, open, handleExport, color, disabled, header } = props;
  const classes = useStyles();
  const appDispatch = useDispatch();

  const handleCopyData = () => {
    if (info && info.length > 0) {
      const headers = Object.keys(info[0]).join('\t');
      const data = [];
      for (const item of info) {
        data.push(
          Object.keys(item)
            .map((key) => item[key])
            .join('\t'),
        );
      }
      navigator.clipboard.writeText(
        [header && `${header}\n`, headers, ...data]
          .filter((e) => e)
          .map((line) => line.replace(/[\r\n]/g, (match) => (match === '\n' ? '\\n' : '\\r'))) // Escapar \n y \r
          .join('\n'),
      );
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: `Copiado en portapapeles`,
          snackbarSeverity: 'info',
        },
      });
      handleClose();
    }
  };

  return (
    <Box mr={1}>
      {!open && (
        <Grid item sm={12}>
          <Button
            disabled={disabled}
            className={`${classes.buttonExport} ${classes[`buttonExport${color}`]}`}
            variant="contained"
            onClick={handleExport}
          >
            {name} (exportar)
          </Button>
        </Grid>
      )}
      {open && (
        <Button
          className={classes.buttonExcelExport}
          variant="contained"
          onClick={handleCopyData}
          disabled={disabled}
          sx={{ mt: '4px' }}
        >
          <img src={ExcelIcon} className={classes.imageExcel} />
          {name} (copiar)
        </Button>
      )}
    </Box>
  );
}

export default ExcelButton;
